import React from 'react'
import type { ModalTriggerProps } from '@ztechapps/webui.modal'
import { SerialNumberTooltip } from './SerialNumberTooltip'
import { BusyButton } from '@ztechapps/webui.button'
import isEmpty from 'lodash/isEmpty'
import type { InventoryBySerialNumber } from '@ztechapps/common.contract'

export type InventoryBySerialNumberModalTriggerProps = ModalTriggerProps & {
  inventoryBySerialNumbers: InventoryBySerialNumber[]
  disabled?: boolean
}
export const InventoryBySerialNumberModalTrigger = (modalTriggerProps: InventoryBySerialNumberModalTriggerProps) => {
  const hasSerialNumbers = !isEmpty(modalTriggerProps.inventoryBySerialNumbers)

  return (
    <SerialNumberTooltip inventoryBySerialNumbers={modalTriggerProps.inventoryBySerialNumbers}>
      <BusyButton
        onClick={modalTriggerProps.onClick}
        disabled={modalTriggerProps.disabled}
        icon={'qrcode'}
        variant={hasSerialNumbers ? 'success' : 'warning'}
      />
    </SerialNumberTooltip>
  )
}
